// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"Title_titleContainer__3KIMs","arrow":"Title_arrow__ni0kM","titleText":"Title_titleText__38x7u"};